/**
 * Created by Slava on 21.06.2024
 */

ExclamationView.prototype.createMsg = cleverapps.extendFunc(ExclamationView.prototype.createMsg, function (message, font) {
    var text = this.createText(message, font);
    text.setRotation(cleverapps.styles.Exclamations.rotation);

    text.setScale(0.5);
    text.opacity = 0;

    text.runAction(new cc.Sequence(
        new cc.DelayTime(0.4),
        new cc.Spawn(
            new cc.FadeIn(0.3),
            new cc.ScaleTo(0.3, 1.3)
        ),
        new cc.ScaleTo(0.1, 0.9),
        new cc.ScaleTo(0.1, 1.1),
        new cc.ScaleTo(0.1, 1),
        new cc.DelayTime(0.5),
        new cc.ScaleTo(0.1, 1.1),
        new cc.Spawn(
            new cc.FadeOut(0.2),
            new cc.ScaleTo(0.2, 0.5)
        ),
        new cc.RemoveSelf()
    ));
});

// the playrix exclamations spine has firework / no_firework instead of the shared "animation"
ExclamationView.prototype.showMessage = function (message, type, callback) {
    this.createAnimation(type === Exclamation.Types.Congrats ? "firework" : "no_firework", callback);
    this.createMsg(message);
};

ExclamationView.prototype.createText = cleverapps.extendFunc(ExclamationView.prototype.createText, function (message, font) {
    font = font || cleverapps.styles.FONTS.CONGRATE_TEXT;
    // eslint-disable-next-line no-restricted-syntax
    var text = cleverapps.UI.generateTTFText(Messages.get(message), font);
    text.fitTo(this.width);

    text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
    text.setAlignment(this.width / 2, this.height / 2);
    this.addChild(text);

    return text;
});